import React from "react";
import { useParams } from "react-router-dom";
import useAccess from "../../hooks/useAccess";
import MyAccountPage from "../User/MyAccountPage";

export default function UserAccountPage() {
  const { id } = useParams();
  const { hasPermission, permissionsLoaded } = useAccess();
  if (!permissionsLoaded) return <div className="p-4" role="status">Loading account access...</div>;
  if (!/^\d+$/.test(id || "") || Number(id) < 1 ||
      !hasPermission("UserProfile", "Personal Information", "view")) {
    return <div className="alert alert-danger m-4">You do not have access to this user account.</div>;
  }
  return <MyAccountPage key={id} selectedUserId={id}
    readOnly={!hasPermission("UserProfile", "Personal Information", "edit")} />;
}

